import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../../core/apis";
import { useStores } from "../../../core/stores";
import { FullScreenLoading } from "../../../ui/Loading";
import { BusinessAdminView } from "../BusinessAdminView";
import { BusinessModuleEdit } from "../ui/BusinessModuleEdit";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "CustomerAdminTemplateSectionModuleEdit"
>;

export const BusinessAdminTemplateSectionModuleEditScreen = observer(
  ({ route }: Props) => {
    const customerUid = route.params.customerUid;
    const templateUid = route.params.templateUid;
    const sectionUid = route.params.sectionUid;
    const moduleUid = route.params.moduleUid;

    const { businessTemplatesApi } = useApi();
    const { businessTemplatesStore } = useStores();

    const template = businessTemplatesStore.byId.get(templateUid);

    const sectionData = template?.data.sections.find(
      (s) => s.uid === sectionUid,
    );
    const templateData = sectionData?.businessModules.find(
      (module) => module.uid === moduleUid,
    );

    React.useEffect(() => {
      return businessTemplatesApi.watchItem(templateUid);
    }, [templateUid, businessTemplatesApi]);

    if (!template || !templateData || !sectionData) {
      return <FullScreenLoading />;
    }

    return (
      <BusinessAdminView customerUid={customerUid}>
        <BusinessModuleEdit
          moduleData={templateData}
          onSave={(newData) =>
            template.updateBusinessTemplateSectionModule(sectionData, newData)
          }
        />
      </BusinessAdminView>
    );
  },
);
